<script setup>
import { Handle, Position, useNode } from '@vue-flow/core';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { TRIGGER_EVENTS } from '../../constants/nodeTypes.js';
import { useNodeAudience } from '../../composables/useNodeAudience.js';

const props = defineProps({
  data: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
const { id } = useNode();
const audienceCount = useNodeAudience(id);

const triggerEvent = computed(() => TRIGGER_EVENTS.find(e => e.key === props.data.event));
const eventLabel = computed(() => triggerEvent.value ? t(triggerEvent.value.label) : t('FLOW_BUILDER.NODES.TRIGGER.SELECT_EVENT'));
const eventIcon = computed(() => triggerEvent.value?.icon || 'i-lucide-play');
</script>

<template>
  <div
    class="flow-node w-[180px] rounded-xl overflow-hidden shadow-md border-2 transition-all"
    :class="selected ? 'border-violet-400' : 'border-transparent'"
  >
    <div class="flex items-center gap-2 px-3 py-2 bg-violet-500 text-white">
      <span :class="[eventIcon, 'size-4 shrink-0']" />
      <span class="text-xs font-semibold flex-1">{{ t('FLOW_BUILDER.NODES.TRIGGER.TITLE') }}</span>
      <span v-if="audienceCount !== null" class="text-[9px] bg-white/20 rounded-full px-1.5 py-0.5 font-medium tabular-nums shrink-0">
        {{ audienceCount }}
      </span>
    </div>
    <div class="px-3 py-2 bg-n-solid-1 text-n-slate-12 text-xs truncate">
      {{ eventLabel }}
    </div>
    <Handle type="source" :position="Position.Bottom" />
  </div>
</template>
